import React from "react";
import { Menu, Radio } from "antd";
import classnames from "classnames";
import UtcDatePicker from "components/Common/UtcDatePicker";
import {
  AddButton,
  SecondaryButton,
} from "components/Common/CustomButtons/CustomButtons";
import { ITEM_VARIANTS } from "./pricerToolbarItems";

// Render helpers (not components) so Menu.Item stays a direct child of
// Menu.ItemGroup, as antd's Menu expects.
//
// `view` carries the shared toolbar state:
//   productsData, buttonSelected, onCompactCommodityClick,
//   datePickerProps, datePickerClassName, datePickerRef

const renderProductButtons = (productsData) =>
  productsData.map((product, index) => (
    <Radio.Button key={`${product}-${index}`} value={product}>
      {product}
    </Radio.Button>
  ));

const renderDatePicker = (item, view, className, forMeasure = false) => (
  <UtcDatePicker
    {...view.datePickerProps}
    disabled={item.disabled}
    ref={forMeasure ? undefined : view.datePickerRef}
    placeholder={item.label}
    className={className}
  />
);

// On-bar view of an item. forMeasure only affects the date picker (no ref).
export const renderInlineItem = (item, view, forMeasure = false) => {
  switch (item.variant) {
    case ITEM_VARIANTS.COMMODITIES:
      return view.productsData.length > 0 ? (
        <Radio.Group
          className="buttons-container__small"
          value={view.buttonSelected}
          onChange={(e) => item.onClick(e.target.value)}
        >
          {renderProductButtons(view.productsData)}
        </Radio.Group>
      ) : null;
    case ITEM_VARIANTS.ADD:
      return <AddButton onClick={item.onClick}>{item.label}</AddButton>;
    case ITEM_VARIANTS.DATE:
      return (
        <span>
          {renderDatePicker(item, view, view.datePickerClassName, forMeasure)}
        </span>
      );
    default:
      return (
        <SecondaryButton
          className="secondary-button--white"
          onClick={item.onClick}
        >
          {item.label}
        </SecondaryButton>
      );
  }
};

// "Pricer Tools" menu view of an item.
export const renderMenuItem = (item, view) => {
  switch (item.variant) {
    case ITEM_VARIANTS.COMMODITIES:
      return (
        <Menu.Item
          key={item.key}
          className="pricer-filter-compact-menu__commodity-row"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="pricer-filter-compact-menu__commodity-pills"
          >
            <Radio.Group
              value={view.buttonSelected}
              onChange={(e) => view.onCompactCommodityClick(e.target.value)}
            >
              {renderProductButtons(view.productsData)}
            </Radio.Group>
          </div>
        </Menu.Item>
      );
    case ITEM_VARIANTS.DATE:
      return (
        <Menu.Item
          key={item.key}
          className="pricer-filter-compact-menu__date-item"
        >
          <div
            className="pricer-filter-compact-menu__date-picker"
            onClick={(event) => event.stopPropagation()}
          >
            {renderDatePicker(
              item,
              view,
              classnames(
                view.datePickerClassName,
                "pricer-filter-compact-menu__date-input"
              )
            )}
          </div>
        </Menu.Item>
      );
    default:
      return (
        <Menu.Item key={item.key} onClick={item.onClick}>
          {item.label}
        </Menu.Item>
      );
  }
};
